import { literal, nullable, number, object, string, union } from "superstruct";

const DiscountRewardSchema = object({
    type: union([literal("discount")]),
    discountType: union([
        literal("percentage"),
        literal("fixed_amount"),
        literal("free_shipping"),
    ]),
    discountValue: nullable(number()),
});

const FreeProductRewardSchema = object({
    type: union([literal("free_product")]),
    discountValue: number(),
    productId: number(),
    productTitle: string(),
    productHandle: string(),
    productImage: nullable(string()),
    variantId: number(),
    variantTitle: string(),
    variantImage: nullable(string()),
});

const GiftCardRewardSchema = object({
    type: union([literal("gift_card")]),
    initialValue: number(),
});

const PointsRewardSchema = object({
    type: union([literal("points")]),
    points: number(),
});

const LeaveReviewEarningRuleSchema = object({
    id: number(),
    type: union([literal("leave_review")]),
    title: string(),
    description: nullable(string()),
    rewarding: union([
        DiscountRewardSchema,
        FreeProductRewardSchema,
        GiftCardRewardSchema,
        PointsRewardSchema,
    ]),
    icon: nullable(string()),
    createdAt: string(),
    extraPointsForPhoto: nullable(number()),
});

export default LeaveReviewEarningRuleSchema;
